export default "__VITE_ASSET__Bz35w2ww__"